import { render, staticRenderFns } from "./addJB.vue?vue&type=template&id=610cefd6&scoped=true&"
import script from "./addJB.vue?vue&type=script&lang=js&"
export * from "./addJB.vue?vue&type=script&lang=js&"
import style0 from "./addJB.vue?vue&type=style&index=0&id=610cefd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cefd6",
  null
  
)

export default component.exports